/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export type InitializeConfigArgs = {
  migratorAllowlist: Array<Address>;
  hookAllowlist: Array<Address>;
  protocolFeeBps: number;
  minSwapFeeBps: number;
  maxSwapFeeBps: number;
};

export type InitializeConfigArgsArgs = InitializeConfigArgs;

export function getInitializeConfigArgsEncoder(): Encoder<InitializeConfigArgsArgs> {
  return getStructEncoder([
    ['migratorAllowlist', getArrayEncoder(getAddressEncoder())],
    ['hookAllowlist', getArrayEncoder(getAddressEncoder())],
    ['protocolFeeBps', getU16Encoder()],
    ['minSwapFeeBps', getU16Encoder()],
    ['maxSwapFeeBps', getU16Encoder()],
  ]);
}

export function getInitializeConfigArgsDecoder(): Decoder<InitializeConfigArgs> {
  return getStructDecoder([
    ['migratorAllowlist', getArrayDecoder(getAddressDecoder())],
    ['hookAllowlist', getArrayDecoder(getAddressDecoder())],
    ['protocolFeeBps', getU16Decoder()],
    ['minSwapFeeBps', getU16Decoder()],
    ['maxSwapFeeBps', getU16Decoder()],
  ]);
}

export function getInitializeConfigArgsCodec(): Codec<
  InitializeConfigArgsArgs,
  InitializeConfigArgs
> {
  return combineCodec(
    getInitializeConfigArgsEncoder(),
    getInitializeConfigArgsDecoder(),
  );
}
